import React from 'react'
import style from './style.module.scss'
import PropTypes from 'prop-types'
import { getImgURL } from '@shared-submodule/utils'
import Image from 'next/future/image'
import nodataArt from '@assets/images/no-data.svg'

function MwebFixtures({ fixture, isMobile = false }) {
  return (<>
    <div className={`d-flex d-md-none flex-column ${style.mwebFixture}`}>
      {fixture?.length ? (fixture?.map((fixture, i) => {
        return (
          <div key={i} id={fixture?.dStartDate} className={`${style.match} d-flex justify-content-between align-items-center`}>
            <div className="d-flex flex-row align-items-center justify-content-start text-center gap-2">
              <Image unoptimized={true} src={getImgURL(fixture?.oTeamScoreA?.oTeam?.oImg?.sUrl)} alt={fixture?.oTeamScoreA?.oTeam?.sAbbr} height={35} width={35} layout='raw' />
              <div className="d-flex flex-column text-start">
                <h6 className="my-0 mt-1">{fixture?.oTeamScoreA?.oTeam?.sAbbr || ''}</h6>
                {fixture?.oTeamScoreA?.sScores && (
                  <span className={style.score}>
                    {fixture?.oTeamScoreA?.sScores || ''} {`(${fixture?.oTeamScoreA?.sOvers || ''})`}
                  </span>
                )}
              </div>
            </div>
            <div className="d-flex flex-column text-center gap-1" style={{ width: '-webkit-fill-available' }}>
              <span className={style.status}>
                {fixture?.sStatusStr === 'live' ? 'Live' : new Date(fixture?.dStartDate).toLocaleString('en-US', {
                  day: 'numeric',
                  month: 'short'
                }) || ''}
              </span>
              <span className={style.place}>
                {fixture?.oVenue?.sLocation}
              </span>
              <span className={style.time} style={{ fontWeight: '600' }}>
                {fixture?.sStatusStr === 'live' ? '' : new Date(fixture?.dStartDate).toLocaleString('en-US', {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true
                }) || ''} IST
              </span>
            </div>
            <div className="d-flex flex-row justify-content-end align-items-center text-center gap-2">
              <div className="d-flex flex-column text-end">
                <h6 className="my-0 mt-1">{fixture?.oTeamScoreB?.oTeam?.sAbbr || ''} </h6>
                {fixture?.oTeamScoreB?.sScores && (
                  <span className={style.score}>
                    {fixture?.oTeamScoreB?.sScores || ''} {`(${fixture?.oTeamScoreB?.sOvers || ''})`}
                  </span>
                )}
              </div>
              <Image unoptimized={true} src={getImgURL(fixture?.oTeamScoreB?.oTeam?.oImg?.sUrl)} alt={fixture?.oTeamScoreB?.oTeam?.sAbbr} height={35} width={35} layout='raw' />
            </div>
          </div>)
      }
      )) : (
        <div className={'my-2 mt-md-5 mb-md-3 text-center'}>
          <div className={' mx-auto mb-2'}>
            <Image unoptimized={true} src={nodataArt} alt="user" height={200} width={200} layout='raw' />
          </div>
            <h3 >{'Stay tuned! The next match goes live soon.'}</h3>
        </div>
      )}
    </div>
  </>
  )
}

MwebFixtures.propTypes = {
  fixture: PropTypes.array,
  isMobile: PropTypes.bool
}

export default MwebFixtures
